/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_S4Inputs */

const en_tut_wb_s4 = /** @type {(inputs: Tut_Wb_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press **Simpan titik simpan** before a big change; **Pulihkan** rolls the board back to that point for everyone.`)
};

const id_tut_wb_s4 = /** @type {(inputs: Tut_Wb_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekan **Simpan titik simpan** sebelum perubahan besar; **Pulihkan** mengembalikan papan ke titik itu untuk semua orang.`)
};

/**
* | output |
* | --- |
* | "Press **Simpan titik simpan** before a big change; **Pulihkan** rolls the board back to that point for everyone." |
*
* @param {Tut_Wb_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_s4 = /** @type {((inputs?: Tut_Wb_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_s4(inputs)
	return en_tut_wb_s4(inputs)
});